/* v1.1.3 — formulário nativo. Nenhum POST é substituído por confirmação simulada. */
(() => {
  const root = document.querySelector('[data-conversion-page]');
  if (!root) return;
  const form = root.querySelector('#TribumetriaConversionForm');
  const params = new URLSearchParams(window.location.search);
  // Apenas etiquetas de campanha desta visita; sem cookies, URL completa ou referrer.
  root.querySelectorAll('[data-campaign-field]').forEach((input) => {
    const raw = params.get(input.dataset.campaignField) || '';
    input.value = /^[a-zA-Z0-9_ .+\-]{1,120}$/.test(raw) ? raw : '';
  });
  const pendingKey = 'tribumetria_diagnostico_pending';
  const success = root.querySelector('[data-lead-success]');
  const errors = root.querySelector('[data-lead-errors]');
  if (errors) errors.focus();
  if (success) {
    success.focus();
    // Só em retorno confirmado pelo Liquid, após submissão nesta aba.
    // Sem PII. A integração de medição deve ouvir este evento e respeitar consentimento.
    let pending = false;
    try {
      const submittedAt = Number(sessionStorage.getItem(pendingKey));
      pending = submittedAt > 0 && Date.now() - submittedAt < 3600000;
      sessionStorage.removeItem(pendingKey);
    } catch (_) { /* Sem armazenamento: confirmação continua; medição conservadora. */ }
    if (pending) document.dispatchEvent(new CustomEvent('tribumetria:lead-success', {
      detail: { form_id: 'TribumetriaConversionForm', page_type: 'diagnostico_fiscal' }
    }));
  }
  form?.addEventListener('submit', (event) => {
    const botField = form.querySelector('.honeypot input');
    if (event.defaultPrevented || botField?.value.trim() || !form.checkValidity()) return;
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (_) {}
  });
})();
